import type { InternalAxiosRequestConfig } from 'axios'

/**
 * FutManager APIs expect the session token on the `auth` header (not Bearer).
 */
export default function authTokenInterceptor(token: string) {
  return (config: InternalAxiosRequestConfig) => {
    if (token && config.headers) {
      config.headers.auth = token
    }
    return config
  }
}
